module.exports = __webpack_public_path__ + "img/jet-flame.d1c36383.png";